module.exports = __webpack_public_path__ + "img/shape.de03f0fc.png";